import { Action } from '@ngrx/store';
import { Categories, Tags } from '@eview/core/domain/tags/tag';

export enum ECategoriesActions {
  ListCategoriesSuccess = '[Categories] List success',
  ListCategoriesFailure = '[Categories] List failure'
}

export class ListCategoriesSuccess implements Action {
  readonly type = ECategoriesActions.ListCategoriesSuccess;
  constructor(public payload: any) {}
}

export class ListCategoriesFailure implements Action {
  readonly type = ECategoriesActions.ListCategoriesFailure;
}

export type CategoriesActions = ListCategoriesSuccess | ListCategoriesFailure;
